// React
import React from 'react'
import PropTypes from 'prop-types'

// Hooks
import { useTranslation } from 'shared/utils/useTranslation'

// Components
import Logo from 'shop-components/components/MiniCart/components/Logo'

// Shared
import { featureEnabled, FeatureFlags } from 'shared/utils/features'

export const PoweredBy = ({ logoWidth }) => {
  const { t } = useTranslation('user')

  let title = t('user.powered_by_short')
  let href = 'https://booqable.com/?source=Shop&campaign=Cart'

  if (featureEnabled(FeatureFlags.EQUIPMENT_RENTAL_SOFTWARE_LINK)) {
    title = t('user.powered_by_equipment_rental_long')
    href = 'https://booqable.com/industries/equipment-rental-software/?source=Shop&campaign=Cart'
  }

  return (
    <a href={href} target="_blank" title={title} rel="noreferrer">
      <Logo width={logoWidth} />
      {t('user.powered_by_short')}
    </a>
  )
}

PoweredBy.propTypes = {
  logoWidth: PropTypes.string
}
